var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.comment)?_c('v-card',{staticClass:"microtrend-comment",attrs:{"flat":"","tile":""}},[_c('v-card-title',[_c('h3',[_vm._v(_vm._s(_vm.$t('components.microtrend.comment.title')))])]),_c('v-card-text',{staticClass:"pt-3",domProps:{"innerHTML":_vm._s(_vm.comment)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }